import React from 'react';
import {
  GridRowCardByRowContainer,
  GridRowCardByRowItem,
  GridRowCardByRowStrong,
  GridRowCardByRowLabel,
  GridRowCardByRowValue,
  GridRowCardByRowButton,
  AnularFooterButton
} from './styles'
import { BsPlus } from 'react-icons/bs';
import { formatPhone, formatIdentification } from '../../helpers/string';
import { formatData } from '../../helpers/date';
import { formatPrice } from '../../helpers/price';
import { useHistory } from 'react-router-dom';
import colors from '../../assets/styles/colors';
import redirectToCorrectPage from '../../services/redirectToCorrectPage';

const GridRowCard = ({ item, canalEstado, setShowModalAnular, setIdCreditAnular }) => {
  const history = useHistory();

  return (
    <GridRowCardByRowContainer id="card">
      <GridRowCardByRowItem>
        <GridRowCardByRowStrong>{item.cliente.nombre}</GridRowCardByRowStrong>
        <GridRowCardByRowValue>CC. {formatIdentification(item.cliente.identificacion)}</GridRowCardByRowValue>
      </GridRowCardByRowItem>
      <GridRowCardByRowItem>
        <GridRowCardByRowLabel>Celular</GridRowCardByRowLabel>
        <GridRowCardByRowValue>{formatPhone(item.cliente.celular)}</GridRowCardByRowValue>
      </GridRowCardByRowItem>
      <GridRowCardByRowItem>
        <GridRowCardByRowLabel>Pagaduría</GridRowCardByRowLabel>
        <GridRowCardByRowValue>{item.pagaduria.nombre}</GridRowCardByRowValue>
      </GridRowCardByRowItem>
      <GridRowCardByRowItem>
        <GridRowCardByRowLabel>Ult. actualización</GridRowCardByRowLabel>
        <GridRowCardByRowValue>{formatData(item.fecha)}</GridRowCardByRowValue>
      </GridRowCardByRowItem>
      <GridRowCardByRowItem>
        <GridRowCardByRowLabel>Monto solicitado</GridRowCardByRowLabel>
        <GridRowCardByRowValue>$ {!item.totalCredito ? 0 : formatPrice(parseInt(item.totalCredito))}</GridRowCardByRowValue>
      </GridRowCardByRowItem>
      <GridRowCardByRowItem>
        <GridRowCardByRowLabel>Cuota mensual aproximada</GridRowCardByRowLabel>
        <GridRowCardByRowValue><strong>$ {formatPrice(parseInt(item.cuota))} </strong> Tasa {item.tasa}% MV</GridRowCardByRowValue>
      </GridRowCardByRowItem>
      <GridRowCardByRowItem>
        <GridRowCardByRowLabel>&nbsp;</GridRowCardByRowLabel>
        {['digicredito','adjuntar','validacion_identidad'].includes(canalEstado) && (
        <GridRowCardByRowButton id="select-item" onClick={() => redirectToCorrectPage(history, item)}>
          <BsPlus color={colors.textPrimary} id="plus-icon" />
        </GridRowCardByRowButton>
        )}
        {canalEstado == "anular" && (
        <AnularFooterButton id="select-item" onClick={() => {setShowModalAnular(true);setIdCreditAnular(item);}}>
          Anular
        </AnularFooterButton>
        )}
      </GridRowCardByRowItem>
    </GridRowCardByRowContainer>
  )
}

export default GridRowCard;
